import { ref, type Ref } from 'vue';
import {
  ensureContentfulPageSyncFetch,
  type UseContentfulPageResponseModel
} from '~/composables/useContentfulPage';

/**
 * Returns the active CMS page payload from `plugins/26.contentfulPagePayload.ts`.
 * Pages must use this instead of `useContentfulPage` so `/api/contentful` is fetched
 * only once per navigation (plugin-owned watcher + `useFetch`).
 */
export async function useContentfulPagePayload(): Promise<
  Ref<UseContentfulPageResponseModel | null>
> {
  await ensureContentfulPageSyncFetch();
  // Guard against the plugin not having run (e.g. error during plugin setup).
  return useNuxtApp().$contentfulPagePayload ?? ref(null);
}
